var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg002Facebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2239_88070)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7654 0C7.98626 0 0.84375 7.17764 0.84375 16C0.84375 24.8217 7.98626 32 16.7654 32C25.544 32 32.6871 24.8217 32.6871 16C32.6871 7.17764 25.5453 0 16.7654 0ZM20.725 16.5633H18.1347V25.8413H14.2963C14.2963 25.8413 14.2963 20.7718 14.2963 16.5633H12.4717V13.2841H14.2963V11.1631C14.2963 9.64408 15.0146 7.27044 18.17 7.27044L21.0143 7.2814V10.4645C21.0143 10.4645 19.2859 10.4645 18.9498 10.4645C18.6138 10.4645 18.136 10.6334 18.136 11.3578V13.2848H21.0604L20.725 16.5633Z",
    fill: "#2E1A47"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2239_88070"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.8434,
    height: 32,
    fill: "white",
    transform: "translate(0.84375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg002Facebook);
export default __webpack_public_path__ + "static/media/002-facebook.dd4f3682220e716d91cef0dfe851bac5.svg";
export { ForwardRef as ReactComponent };